import React from "react";
import { Styles } from "./styles";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const Panels = ({ panelsStats }) => {
  // Map the API data to the chart data format
  const labelsMap = {
    success: "Success get services panels",
    failed: "Failed get services panels",
    expired: "Expired panels",
    not_expired: "Not Expired panels",
  };

  // Generate labels and data dynamically
  const labels = panelsStats.map(
    (stat) => labelsMap[stat.status] || stat.status
  );
  const dataCount = panelsStats.map((stat) => stat.count);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Panel Statistics",
        data: dataCount,
        backgroundColor: [
          "#114787",
          "#58A4B0",
          "#d71814",
          "#72aefa",
        ],
        borderColor: [
          "#114787",
          "#58A4B0",
          "#d71814",
          "#72aefa",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Options for the Doughnut Chart
  const options = {
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <Styles>
      <div
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <div className="title mb-2">{data?.datasets[0]?.label}</div>
        <Doughnut data={data} options={options} />
      </div>
    </Styles>
  );
};

export default Panels;
